<template>
  <header class="phone sticky-header">
    <header-top-vue />
    <header-bottom-vue :heading="heading" :specific-link="'PHONE'" />
  </header>
</template>

<script>
import HeaderTopVue from "../common/HeaderTop";
import HeaderBottomVue from "../common/HeaderBottom";
import { mapGetters } from "vuex";

export default {
  components: {
    HeaderTopVue,
    HeaderBottomVue
  },
  computed: {
    ...mapGetters("favourites", {
      favouriteMode: "getFavouriteMode"
    }),
    heading() {
      if (this.favouriteMode) {
        return "Phone Favourites";
      } else {
        return "Phone";
      }
    }
  }
};
</script>

<style scoped>
header >>> .year-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  line-height: 18px;
}

header >>> .header-icon-contain {
  padding: 2px 0px 0px 0px;
}
</style>
